import { Action } from 'react-fetching-library';

export function deleteFile(fileId: number): Action {
  return {
    method: 'DELETE',
    endpoint: 'files',
    id: fileId,
  };
}
